import BaseApi from '@/api/Base/BaseApi'
import { ExportGroupPayload, GroupNodeBase, GroupPipelineInfo } from '@/api/Group/types'

const ROOT = '/group'

export default class GroupApi extends BaseApi {
  getGroupInfo(groupNodeId: string) {
    return this.agent.get<GroupNodeBase>(`${ROOT}/${groupNodeId}`)
  }

  getGroupPipeline(groupNodeId: string) {
    return this.agent.get<GroupPipelineInfo>(`${ROOT}/${groupNodeId}/pipeline`)
  }

  // NOTE: 인스턴스 노드별로 roi 옵션을 줘야 할 필요가 있는지 확인 필요
  exportGroup(payload: ExportGroupPayload) {
    const { groupNodeId, ...rest } = payload
    return this.agent.post(`${ROOT}/${groupNodeId}/export`, rest)
  }

  downloadGroup(groupNodeId: string) {
    return this.agent.post(`${ROOT}/${groupNodeId}/download`, {}, { responseType: 'blob' })
  }
}
